export const initialState = {
  values: []
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnReportParameterPropertyChanged':
      return OnReportParameterPropertyChanged(state, action);
    case 'OnReportParameterAdded':
      return OnReportParameterAdded(state, action);
    case 'OnReportParameterDeleted':
      return OnReportParameterDeleted(state, action);
    case 'OnReportParameterExpanded':
      return onReportParameterExpanded(state, action);
    case 'OnReportParameterSaved':
      return OnReportParameterSaved(state, action);
    default:
      return state;
  }
}

function onInitState(state, action) {
  const { data } = action;
  return {
    ...state,
    values: data.map(item => {
      return { ...item, changed: false, isExpanded: false };
    })
  };
}

function OnReportParameterPropertyChanged(state, action) {
  const { propertyName, value, index } = action;
  return {
    ...state,
    values: Object.assign([...state.values], {
      [index]: {
        ...state.values[index],
        [propertyName]: value,
        changed: true
      }
    })
  };
}

function OnReportParameterAdded(state, action) {
  const reportParameter = {
    reportParameterId: null,
    reportId: action.reportId,
    paramName: '',
    reportParameterTypeId: null,
    filterCode: '',
    filterMember: '',
    reportContextParameter: '',
    isExpanded: true
  };
  const newReportParameters = Object.assign([...state.values]);
  newReportParameters.push({ ...reportParameter, changed: true });
  return {
    ...state,
    values: newReportParameters
  };
}

function OnReportParameterDeleted(state, action) {
  const { index } = action;
  const newParameters = Object.assign([...state.values]);
  newParameters.splice(index, 1);
  return {
    ...state,
    values: newParameters
  };
}

const onReportParameterExpanded = (state, action) => {
  const { index, isExpanded } = action;
  return {
    ...state,
    values: Object.assign([...state.values], {
      [index]: {
        ...state.values[index],
        isExpanded: isExpanded
      }
    })
  };
};

function OnReportParameterSaved(state, action) {
  const { index } = action;
  return {
    ...state,
    values: Object.assign([...state.values], {
      [index]: {
        ...state.values[index],
        changed: false
      }
    })
  };
}
